import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import React from 'react'
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import TextField from '../../Reusable/Form/TextInput';
import Button from '../../Reusable/Button';

let exchangeOrderValidationForm = yup.object().shape({
  cod: yup.string().required("Cod is required"),
});


const Exchange = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError
  } = useForm<any>({
    resolver: yupResolver(exchangeOrderValidationForm),
    defaultValues: async () => {
      return {
        cod: 0,
      }
    }
  })
  return (
    <div>
      <h1 className='text-sm text-gray-500'>Exchange Order will create two new order</h1>
      <div>
        <TextField
          label={"Exchange COD"}
          register={register("cod")}
          errors={errors?.primary_order_amount}
        />
      </div>
      <div className='flex justify-end w-full'>
      <div className="w-[100px]">
        <Button
          label={"Submit"}
          onClick={handleSubmit((data: any) =>
            props?.handleActionMenu(data, "Exchange", setError)
          )}
        />
      </div>
      </div>
      
    </div>
  )
}

export default Exchange
